import { apiFetch } from './client';

export type UnitSystem = 'imperial' | 'metric';

export interface LocationConfig {
  latitude: number;
  longitude: number;
  zoom: number;
  unitSystem: UnitSystem;
}

export async function fetchLocationConfig(tenant?: string): Promise<LocationConfig> {
  return apiFetch<LocationConfig>('/api/v1/tenant/config', {
    method: 'GET',
    tenant,
  });
}
